import * as React from "react";
import { useState, useEffect, useRef } from "react";
// import { useHistory } from "react-router-dom";
import "../../Styles/style.css";
import InspectedImage from "../../../images/famewheels-inspected-icon.png";
import CertifiedImage from "../../../images/famewheels-certified-icon.png";
import DocsComplete from "../../../images/docs-completed.png";
import DocsInComplete from "../../../images/docs-incomplete.png";
import { Carousel } from "react-bootstrap";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import NotificationSound from "../../../images/notification-sound.mp3";
import { baseUrl } from "../../../api/ipconfig";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import BidRejected from "../../modals/bid-reject";
import { AuthContext } from "../../../context/AuthContext.js";
import WinnerAnounced from "../../modals/winner-announced";
import ReportDumy from "../../../images/report-dumy.png";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import Zoom from "@mui/material/Zoom";

import { Alert, Snackbar, Tooltip } from "@mui/material";
import { Helmet } from "react-helmet";
import { Link, useHistory } from "react-router-dom";
import NumberLogin from "../../loginModal/number.jsx";
import Lottie from "lottie-react";
import LiveAnimation from "../../../images/json/live.json";

const FullPreview = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  bgcolor: "#00000000",
  p: 4,
  borderRadius: "10px",
  maxHeight: "95%",
  height: "100%",
  overflowY: "scroll",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: theme.palette.mode === "dark" ? "#2ECA45" : "#4fb850",
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color:
        theme.palette.mode === "light"
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === "light" ? "#E9E9EA" : "#39393D",
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

export default function BiddingVehicleDeatilsBody() {
  // const { dispatch } = useAuthContext();
  const { user } = React.useContext(AuthContext);
  const token = localStorage.getItem("token");

  const history = useHistory();

  // const { postId } = useParams();
  const [vehicleDetail, setVehicleDetail] = useState(null);
  const [auctionDetail, setAuctionDetail] = useState(null);
  const [bidDetails, setBidDetails] = useState([]);
  const [imagesPath, setImagesPath] = useState("");
  const [vehicleImages, setVehicleImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [auctionId, setAuctionId] = useState(0);
  const [vehicleFeatures, setVehicleFeatures] = useState(null);
  const [postErrOpen, setPostErrorOpen] = React.useState(false);

  // const defaultValue = 1000;
  const [highest, setHighest] = useState(0);
  const [startingmount, setStartingAmount] = useState();
  const [value, setValue] = useState("");
  const [msg, setMsg] = useState("");

  const [errResponse, setErrResponse] = useState("");

  const [bidNowOpen, setBidNowOpen] = useState(false);

  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    setValue(parseInt(highest || startingmount));
  }, [highest, startingmount]);

  // console.log(hours, "hours");
  // console.log(minutes, "minutes");
  // console.log(seconds, "seconds");

  // console.log(postId, 'post id')

  // useEffect(() => {
  //   const audio = new Audio('../../images/lele.mp3');
  //   audio.play();

  //   return () => {
  //     audio.pause();
  //   };
  // }, []);

  useEffect(() => {
    const url = new URL(window.location.href);
    const hidden = url.searchParams.get("hidden");

    if (hidden === "true") {
      setIsHidden(true);
    }
  }, []);

  const extractPostIdFromUrl = (url) => {
    const parts = url.split("/");
    return parts[parts.length - 1];
  };

  const url = window.location.href;
  const postId = extractPostIdFromUrl(url);

  const [newBids, setNewBids] = useState("");
  const prevBidDetailsLength = useRef(bidDetails?.length);
  const isInitialRender = useRef(true);

  const sendVisitorDetail = async () => {
    try {
      const response = await axios.get(`${baseUrl}/saveauctionvisitor`, {
        params: {
          auctionpost_id: postId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/auctionpostdetail`, {
        params: {
          post_id: postId,
          userId: user?.id || 0,
        },
      });

      setVehicleDetail(response?.data?.postDetail);
      setAuctionDetail(response?.data?.data);
      setStartingAmount(parseInt(response?.data?.data?.starting_amount));
      setVehicleFeatures(JSON.parse(response?.data?.postDetail?.car_features));

      try {
        const imageResponse = await axios.get(`${baseUrl}/postimages`, {
          params: {
            post_id: response?.data?.postDetail?.post_token,
          },
        });

        setVehicleImages(imageResponse?.data?.images);
        setImagesPath(imageResponse?.data?.imagepath);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    setAuctionId(postId);
    sendVisitorDetail(postId);
  }, []);

  const fetchBidData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/bidinglist`, {
        params: {
          post_id: postId,
        },
      });
      const newBidData = response?.data?.data || [];

      setBidDetails(newBidData);
      // setBidDetails(response?.data?.data);
      if (newBidData.length > 0) {
        const first = newBidData[0];
        await setHighest(first?.bid_amount);
      }
      // const first = response?.data?.data[0] || [];
      // await setHighest(first?.bid_amount);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };
  useEffect(() => {
    const intervalId = setInterval(fetchBidData, 1000); // Call API every 10 seconds

    return () => {
      clearInterval(intervalId); // Clear interval when component unmounts
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const intervalId = setInterval(fetchData, 1000); // Call API every 10 seconds

    return () => {
      clearInterval(intervalId); // Clear interval when component unmounts
    };
  }, []);

  const [soundEnabled, setSoundEnabled] = useState(true);

  const handleSoundNotificationChange = (event) => {
    setSoundEnabled(event.target.checked);
  };

  useEffect(() => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  }, []);

  const showNotification = () => {
    if (Notification.permission === "granted" && navigator.serviceWorker) {
      navigator.serviceWorker.ready.then((registration) => {
        const title = `New Bid on ${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`;
        const options = {
          body: `${
            bidDetails[0]?.name
          } bid PKR ${bidDetails[0]?.bid_amount?.toLocaleString()} on ${
            vehicleDetail?.makeName
          } ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`,
          icon: `${imagesPath}/${vehicleDetail?.post_token}/${vehicleImages[0]?.filename}`,
          vibrate: 5,
        };

        registration.showNotification(title, options);
      });
    }
  };

  const [latestBid, setlatestBid] = useState("");

  useEffect(() => {
    if (isInitialRender.current) {
      isInitialRender.current = false;
    } else {
      // console.log(prevBidDetailsLength.current, " prev length");
      // console.log(bidDetails?.length, " bids length");
      // Check if a new bid has been added
      if (bidDetails?.length > prevBidDetailsLength.current) {
        setlatestBid(bidDetails[0]?.bid_id);
        console.log(latestBid, " latest bid ");
        const newBid = latestBid;
        setNewBids(newBid);

        console.log(newBids, "new bid arrived");

        // Update the previous length to the current length
        prevBidDetailsLength.current = bidDetails?.length;

        if (newBids !== "" && Notification.permission === "granted") {
          showNotification();
        }
        // Play the sound
        if (soundEnabled === true) {
          const audio = new Audio(NotificationSound);
          audio.play();

          return () => {
            audio.pause();
            audio.currentTime = 0;
          };
        }
      }
    }
  }, [bidDetails, soundEnabled]);

  // useEffect(() => {
  //   let replicafetchData = localStorage.getItem("data");
  //   let fetchData = JSON.parse(replicafetchData);
  //   setUser(fetchData);
  // }, []);

  // useEffect(() => {
  //   document.title = `${vehicleDetail && vehicleDetail?.title} | Live Bidding`;
  // }, [vehicleDetail]);

  const [isMemberOpen, setIsMemberOpen] = useState(false);
  const [winnerOpen, setWinnerOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // const [user, setUser] = useState(null);
  const [bidWinner, setBidWinner] = useState(null);

  const [auctionEnd, setAuctionEnd] = useState(false);
  const [userCredit, setUserCredit] = useState(null);

  useEffect(() => {
    const fetchCredits = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${baseUrl}/getTotalAmount`, {
          params: {
            user_id: user?.id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUserCredit(response?.data);

        // setLoading(false);
      } catch (error) {
        console.error("Error fetching user posts:", error);
        // setLoading(false);
      }
    };

    if (user) {
      fetchCredits();
    }
  }, [user]);

  const MemberBidOpen = () => {
    setIsMemberOpen(true);
  };

  const MemberBidClose = () => {
    setIsMemberOpen(false);
  };

  const WinnerModalClose = () => {
    setWinnerOpen(false);
  };

  const LoginOpen = () => {
    setIsOpen(true);
  };
  const PurchaseBidOpen = () => {
    history.push("/become-a-member");
  };

  const LoginClose = () => {
    setIsOpen(false);
  };

  //preview full size image

  // const images = [
  //   Photo1,
  //   Photo2,
  //   Photo3,
  //   Photo4,
  // ]; // Replace with the actual paths to your images

  const [previewOpen, setPreviewOpen] = React.useState(false);
  // const handlePreviewOpen = () => setPreviewOpen(true);
  const handlePreviewClose = () => setPreviewOpen(false);

  const handleImageClick = (index) => {
    setPreviewOpen(true);
  };

  // var replicafetchData = localStorage.getItem("data");
  // var fetchData = JSON.parse(replicafetchData);
  // setUser(fetchData);

  const formatPrice = (price) => {
    if (price >= 100000000000) {
      return (
        (price / 100000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Kharab"
      );
    } else if (price >= 1000000000) {
      return (
        (price / 1000000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Arab"
      );
    } else if (price >= 10000000) {
      return (
        (price / 10000000).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }) + " Crore"
      );
    } else if (price >= 100000) {
      return (
        (price / 100000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " lacs"
      );
    } else if (price >= 1000) {
      return (
        (price / 1000).toLocaleString("en-US", { maximumFractionDigits: 2 }) +
        " Thousand"
      );
    } else {
      return price?.toLocaleString("en-US", { maximumFractionDigits: 2 });
    }
  };

  const BidSubmit = async (e) => {
    e.preventDefault();
    try {
      if (value === highest) {
        setPostErrorOpen(true);
        setMsg("Place a higher bid than current");
      } else {
        setBidNowOpen(false);
        const token = localStorage.getItem("token");

        const formData = new FormData();

        // Append form field values
        formData.append("bid_amount", value);
        formData.append("user_id", user?.id);
        formData.append("auction_post_id", auctionId);

        await axios.post(`${baseUrl}/savebid`, formData, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        });
        setMsg("");
        // setTimeout(() => {
        //   Window.reload();
        // }, 3000);

        // console.log(response, "Bid Successfully");
      }
    } catch (err) {
      console.log(err.response);
      setErrResponse(err?.response?.data);
      setMsg(err?.response?.data);
      setPostErrorOpen(true);
      // MemberBidOpen();
    }
  };

  const increaseValue = () => {
    setValue((prevValue) => prevValue + 10000);
    setMsg("");
  };

  const decreaseValue = () => {
    setValue((prevValue) => prevValue - 10000);
  };

  const limitedImages = vehicleImages && vehicleImages.slice(0, 8);

  const [remainingTime, setRemainingTime] = useState("");
  const [progress, setProgress] = useState(0);

  // useEffect(() => {
  //   if (auctionDetail) {
  //     const calculateRemainingTime = () => {
  //       const now = new Date();
  //       const nowInPakistanTime = new Date(
  //         now.toLocaleString("en-US", { timeZone: "Asia/Karachi" })
  //       );
  //       const endDateTime = new Date(
  //         nowInPakistanTime.toDateString() +
  //           " " +
  //           auctionDetail?.auction_end_time
  //       );
  //       const startDateTime = new Date(
  //         nowInPakistanTime.toDateString() +
  //           " " +
  //           auctionDetail?.auction_start_time
  //       );

  //       if (nowInPakistanTime < startDateTime) {
  //         const diff = startDateTime - nowInPakistanTime;
  //         setRemainingTime(` ${formatTimeDiff(diff)}`);
  //       } else if (
  //         nowInPakistanTime >= startDateTime &&
  //         nowInPakistanTime < endDateTime
  //       ) {
  //         const diff = endDateTime - nowInPakistanTime;
  //         setRemainingTime(` ${formatTimeDiff(diff)}`);
  //         const totalDuration = endDateTime - startDateTime;
  //         const elapsedDuration = endDateTime - nowInPakistanTime;
  //         const progressPercentage = (elapsedDuration / totalDuration) * 100;

  //         setProgress(progressPercentage);
  //       } else {
  //         setRemainingTime("Auction has ended");
  //         setProgress(100);
  //         setAuctionEnd(true);
  //         // history.push(`/bidding`);
  //       }
  //     };

  //     const formatTimeDiff = (timeDiff) => {
  //       const hours = Math.floor(timeDiff / (1000 * 60 * 60));
  //       const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
  //       const seconds = Math.floor((timeDiff / 1000) % 60);
  //       return `${hours}h ${minutes}m ${seconds}s`;
  //     };

  //     calculateRemainingTime();
  //     const intervalId = setInterval(calculateRemainingTime, 1000);
  //     return () => clearInterval(intervalId);
  //   }
  // }, [auctionDetail?.auction_end_time, auctionDetail?.auction_start_time]);

  useEffect(() => {
    if (auctionDetail) {
      const calculateRemainingTime = () => {
        const serverDateTime = new Date(
          `${auctionDetail?.serverdate}T${auctionDetail?.servertime}Z`
        );

        const auctionStartTimeParts =
          auctionDetail?.auction_start_time.split(":");
        const auctionEndTimeParts = auctionDetail.auction_end_time.split(":");

        const auctionStartDateTime = new Date(
          `${auctionDetail?.auction_date}T${auctionStartTimeParts[0]}:${auctionStartTimeParts[1]}:${auctionStartTimeParts[2]}Z`
        );

        const auctionEndDateTime = new Date(
          `${auctionDetail?.auction_date}T${auctionEndTimeParts[0]}:${auctionEndTimeParts[1]}:${auctionEndTimeParts[2]}Z`
        );

        if (serverDateTime < auctionStartDateTime) {
          const diff = auctionStartDateTime - serverDateTime;
          setRemainingTime(` ${formatTimeDiff(diff)}`);
        } else if (
          serverDateTime >= auctionStartDateTime &&
          serverDateTime < auctionEndDateTime
        ) {
          const diff = auctionEndDateTime - serverDateTime;
          setRemainingTime(` ${formatTimeDiff(diff)}`);
          const totalDuration = auctionEndDateTime - auctionStartDateTime;
          const elapsedDuration = auctionEndDateTime - serverDateTime;
          const progressPercentage = (elapsedDuration / totalDuration) * 100;

          setProgress(progressPercentage);
        } else {
          setRemainingTime("Auction has ended");
          setProgress(100);
          setAuctionEnd(true);
          // history.push(`/bidding`);
        }
      };

      const formatTimeDiff = (timeDiff) => {
        const hours = Math.floor(timeDiff / (1000 * 60 * 60));
        const minutes = Math.floor((timeDiff / (1000 * 60)) % 60);
        const seconds = Math.floor((timeDiff / 1000) % 60);
        return `${hours}h ${minutes}m ${seconds}s`;
      };

      calculateRemainingTime();
      const intervalId = setInterval(calculateRemainingTime, 1000);
      return () => clearInterval(intervalId);
    }
  }, [
    auctionDetail?.auction_end_time,
    auctionDetail?.auction_start_time,
    auctionDetail?.auction_date,
    auctionDetail?.serverdate,
    auctionDetail?.servertime,
  ]);

  useEffect(() => {
    const fetchBidWinner = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${baseUrl}/auctionwinnerdetail`, {
          params: {
            post_id: postId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        setBidWinner(response?.data?.data);
        setWinnerOpen(true);
      } catch (error) {
        console.error("Error fetching bid winner:", error);
      }
    };

    if (isHidden === false) {
      if (auctionEnd === true || setRemainingTime === "Auction has ended") {
        fetchBidWinner();
      }
    }
  }, [auctionEnd, remainingTime]);

  const myAllBids = bidDetails?.filter((item) => item?.user_id === user?.id);

  const myMaxBid =
    myAllBids?.length > 0
      ? Math.max(...myAllBids?.map((item) => item?.bid_amount))
      : null;

  const isBidFound = bidDetails?.some((item) => item?.user_id === user?.id);

  const handleReport = () => {
    window.open(
      `https://www.inspectionreport.famewheels.com/inspection-report/${auctionDetail?.iinitial_token}`,
      "_blank"
    );
  };

  const handleBarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
  };

  const handlePostClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setPostErrorOpen(false);
  };

  const availableBids = userCredit?.totalamount / userCredit?.bid_amount;

  const addAmount = [3000, 5000, 7000, 10000];

  const handleAmountPress = (amount) => {
    setValue(value + amount);
    setMsg("");
  };

  const ResetToHighest = () => {
    setValue(parseInt(highest || startingmount));
  };

  return (
    <>
      <Helmet>
        <title>{`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName} | Live Bidding`}</title>
        <meta name="description" content={vehicleDetail?.description} />
        {/* Open Graph (Facebook) */}
        <meta
          property="og:title"
          content={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
        />
        <meta property="og:description" content={vehicleDetail?.description} />
        <meta
          property="og:image"
          content={`${baseUrl}/public/posts/${vehicleDetail?.post_token}/${vehicleDetail?.cover}`}
        />
        <meta property="og:url" content={window.location.href} />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
        />
        <meta name="twitter:description" content={vehicleDetail?.description} />
        <meta
          name="twitter:image"
          content={`${baseUrl}/public/posts/${vehicleDetail?.post_token}/${vehicleDetail?.cover}`}
        />

        {/* WhatsApp */}
        <meta property="og:type" content="article" />
      </Helmet>
      {/* <audio src={Lele} autoPlay /> */}

      <Snackbar
        open={postErrOpen}
        autoHideDuration={2500}
        onClose={() => setPostErrorOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handlePostClose}
          severity="error"
          sx={{ width: "100%", backgroundColor: "#a1e334" }}
        >
          {msg}
        </Alert>
      </Snackbar>

      <div className=" colorBg_new d-none d-lg-block "></div>

      <div className="container pt-3 pb-5">
        <div className="row">
          <div className="col-lg-12 px-3 py-2" style={{ borderRadius: 10 }}>
            <div className="d-block d-lg-flex align-items-stretch justify-content-between">
              <div>
                <div className="vehicleDetails_title text-capitalize">
                  <h4 className="m-0">
                    {" "}
                    {vehicleDetail?.makeName} {vehicleDetail?.modelName}{" "}
                    {vehicleDetail?.yearName}{" "}
                  </h4>
                  {/* 
              <p className="adlocation">
                <i className="fa-solid fa-location-dot me-2"></i>
                {vehicleDetail?.city_name}
              </p> */}
                </div>
                <div className="vehicleDetails_price pb-2 ">
                  {highest !== 0 ? (
                    <>
                      <div>
                        {/* <p className="mb-0 pt-2"> Starting from </p> */}
                        <strong>
                          {/* PKR {formatPrice(auctionDetail?.starting_amount)}{" "} */}
                          PKR {formatPrice(highest)}{" "}
                        </strong>
                      </div>
                      <div className="d-flex justify-content-start align-items-end">
                        <p className="mb-0 pe-1"> Started from </p>
                        <strong className="fs-6 fw-600">
                          {/* PKR {formatPrice(auctionDetail?.starting_amount)}{" "} */}
                          PKR {formatPrice(auctionDetail?.starting_amount)}{" "}
                        </strong>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <p className="mb-0 pt-2"> Starting from </p>
                        <strong>
                          PKR {formatPrice(auctionDetail?.starting_amount)}{" "}
                        </strong>
                      </div>
                    </>
                  )}
                </div>
                <div className="d-flex flex-wrap row-gap-2 align-items-center justify-content-start mb-3 ">
                  <div className="vehicle_pills  card_bg px-3 py-2 rounded-3 me-3 ">
                    <h6>
                      <i className="fa-solid fa-location-dot me-2"></i>
                      {vehicleDetail?.city_name}
                    </h6>
                  </div>
                  {/* <div className="vehicle_pills  card_bg px-3 py-2 rounded-3 me-3 ">
                    <h6>
                      <i className="fa-regular fa-calendar me-1 "></i>{" "}
                      {vehicleDetail?.yearName}
                    </h6>
                  </div> */}
                  <div className="vehicle_pills  card_bg px-3 py-2 rounded-3 me-3 ">
                    <h6>
                      <i className="fa-solid fa-car-side me-1 "></i>{" "}
                      {vehicleDetail?.transmission}
                    </h6>
                  </div>
                  <div className="vehicle_pills  card_bg px-3 py-2 rounded-3 me-3 ">
                    <h6>
                      <i className="fa-solid fa-gas-pump me-1 "></i>{" "}
                      {vehicleDetail?.vehicle_fuel}
                    </h6>
                  </div>
                  <div className="vehicle_pills  card_bg px-3 py-2 rounded-3 me-3 ">
                    <h6>
                      <i className="fa-solid fa-arrow-up-right-dots me-1 "></i>{" "}
                      {vehicleDetail?.milage} KM
                    </h6>
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <div className=" d-flex  pe-3 my-3">
                    {auctionDetail?.iinitial_token !== 0 && (
                      <div>
                        {/* <img
                        className="inspected_icon"
                        src={InspectedImage}
                        alt="Inspected Car"
                      /> */}
                        <img
                          className="inspected_icon"
                          src={CertifiedImage}
                          alt="Inspected Car"
                        />
                      </div>
                    )}
                    {auctionDetail?.document_completed === "yes" ? (
                      <img
                        className="inspected_icon"
                        src={DocsComplete}
                        alt="Documents Complete"
                      />
                    ) : auctionDetail?.document_completed === "no" ? (
                      <img
                        className="inspected_icon"
                        src={DocsInComplete}
                        alt="Documents Incomplete"
                      />
                    ) : null}
                  </div>
                  <div className="d-flex d-md-none align-items-center justify-content-end">
                    <div
                      style={{ width: "fit-content" }}
                      className="d-flex bgSecondary ps-2 pe-3  rounded-2 align-items-center"
                    >
                      <Lottie
                        style={{ height: 30, width: "fit-content" }}
                        animationData={LiveAnimation}
                        loop
                      />
                      <h6
                        style={{ fontSize: 12 }}
                        className="text-white mb-0 ms-2"
                      >
                        LIVE
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex flex-row-reverse flex-lg-column mb-2 mb-lg-0 justify-content-between ">
                <div className="d-none d-md-flex align-items-center justify-content-end">
                  <div
                    style={{ width: "fit-content" }}
                    className="d-flex bgSecondary ps-2 pe-3 py-1 rounded-2 align-items-center"
                  >
                    <Lottie
                      style={{ height: 30, width: "fit-content" }}
                      animationData={LiveAnimation}
                      loop
                    />
                    <h6 className="text-white mb-0 ms-2">LIVE</h6>
                  </div>
                </div>
                <div className="d-flex mb-3 w-100 flex-md-row-reverse justify-content-between align-items-center">
                  <div className="bg-dark timeLeft_bgW px-2 px-md-3 py-2  rounded-3 ">
                    <h6 className="text-white mb-0 fw-700">
                      <span className="opacity-75 fs-6 fw-500">
                        <i className="fa-regular fa-clock me-2 "></i>Time Left:
                      </span>{" "}
                      {remainingTime}
                    </h6>
                  </div>
                  <Tooltip
                    title={
                      soundEnabled === true
                        ? "You'll be notified for new bids. "
                        : "No notification sound for new bids."
                    }
                    arrow
                    placement="top"
                    TransitionComponent={Zoom}
                    enterDelay={10}
                    leaveDelay={100}
                  >
                    <FormControlLabel
                      control={
                        <IOSSwitch
                          sx={{ m: 1 }}
                          checked={soundEnabled}
                          onChange={handleSoundNotificationChange}
                        />
                      }
                      label="Notify Me"
                    />
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row row-gap-2 ">
          <div className="col-xl-8 col-lg-7 col-md-12 col-12">
            <div className="bidding-image-gallery">
              {vehicleImages && vehicleImages.length > 0 && (
                <>
                  <div className="main-image">
                    <img
                      className="d-block w-100 rounded-4"
                      src={`${imagesPath}/${vehicleDetail?.post_token}/${vehicleImages[0]?.filename}`}
                      alt={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
                      onClick={() => handleImageClick(0)}
                      onError={(e) => {
                        e.target.src =
                          "https://gallery.famewheels.com/appgallery/no-image.png";
                      }}
                    />
                  </div>
                  <div className="side-images">
                    {vehicleImages.slice(1, 4).map((image, index) => (
                      <div
                        key={index + 1}
                        className="side-image"
                        onClick={() => handleImageClick(index + 1)}
                      >
                        <img
                          className="d-block w-100 rounded-4"
                          src={`${imagesPath}/${vehicleDetail?.post_token}/${image?.filename}`}
                          alt={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
                        />
                      </div>
                    ))}
                    {vehicleImages.length > 5 && (
                      <div className="more-images">
                        <div
                          className="overlay"
                          onClick={() => handleImageClick(5)}
                        >
                          +{vehicleImages.length - 5}
                        </div>
                        <img
                          className="d-block w-100 rounded-4"
                          src={`${imagesPath}/${vehicleDetail?.post_token}/${vehicleImages[5]?.filename}`}
                          alt={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
                        />
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4">
              <div className="w-100 me-0 me-md-3 d-flex justify-content-between align-items-center bg-dark px-3 py-3  rounded-3  ">
                <div>
                  <h6
                    style={{ fontSize: 14 }}
                    className="text-white mb-0 fw-700 d-flex text-center column-gap-1 "
                  >
                    <span className="opacity-75  fw-500">
                      <i className="fa-regular fa-clock me-2 "></i>Time Left:
                    </span>{" "}
                    <span>{remainingTime}</span>
                  </h6>
                </div>
                <div className="ms-3">
                  <h6
                    style={{ fontSize: 14 }}
                    className="text-white mb-0 fw-700 d-flex  text-center column-gap-1"
                  >
                    <span className="opacity-75  fw-500">
                      <i className="fa-solid fa-arrow-up-long me-2 "></i>Highest
                      Bid:
                    </span>{" "}
                    <span>{formatPrice(highest || 0)}</span>
                  </h6>
                </div>
                {/* {user && user?.role_id === 3 ? (
                  <div className="ms-3 ">
                    <h6
                      style={{ fontSize: 14 }}
                      className="text-white mb-0 fw-700 d-flex flex-column d-md-block text-center"
                    >
                      <span
                        style={{ whiteSpace: "nowrap" }}
                        className="opacity-75  fw-500"
                      >
                        <i className="fa-solid fa-hashtag me-2 "></i>Available
                        Bids:
                      </span>{" "}
                      <span>{availableBids}</span>
                    </h6>
                  </div>
                ) : ( */}
                <div className="ms-3 d-none d-xl-block d-lg-black d-md-none  ">
                  <h6
                    style={{ fontSize: 14 }}
                    className="text-white mb-0 fw-700 d-flex flex-column d-md-block text-center"
                  >
                    <span className="opacity-75  fw-500">
                      <i className="fa-solid fa-hashtag me-2 "></i>Total Bids:
                    </span>{" "}
                    <span>{bidDetails?.length}</span>
                  </h6>
                </div>
                {/*  )} */}
              </div>
              <div className="mt-3 mt-md-0 mb-2 mb-md-0">
                <div className="btnBid ">
                  {user && user ? (
                    <>
                      {userCredit?.activeamount === 0 &&
                      isBidFound === false ? (
                        <Button
                          onClick={PurchaseBidOpen}
                          variant="contained"
                          className="py-2 px-5 py-md-3 px-md-4 color-white fw-700 bgSecondary rounded-3 text-capitalize"
                          sx={{ lineHeight: "unset", whiteSpace: "nowrap" }}
                        >
                          Purchase Bid
                        </Button>
                      ) : userCredit?.activeamount !== 0 ? (
                        <>
                          {/* <form onSubmit={BidSubmit} className="postAdForm">
                          <Button
                            // type="submit"
                            variant="contained"
                            className="py-2 px-5 py-md-3 px-md-4 color-white fw-700 bgSecondary rounded-3 text-capitalize"
                            sx={{
                              lineHeight: "unset",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Bid Now
                          </Button>
                        </form> */}

                          {auctionEnd !== true && (
                            <Button
                              // type="submit"
                              onClick={() => setBidNowOpen(true)}
                              variant="contained"
                              className="py-2 px-5 py-md-3 px-md-4 color-white fw-700 bgSecondary rounded-3 text-capitalize"
                              sx={{
                                lineHeight: "unset",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Place Bid
                            </Button>
                          )}
                        </>
                      ) : null}
                    </>
                  ) : (
                    <Button
                      onClick={LoginOpen}
                      variant="contained"
                      className="py-3 px-4 color-white fw-700 bgSecondary rounded-3 text-capitalize"
                      sx={{ lineHeight: "unset", whiteSpace: "nowrap" }}
                    >
                      Login to Bid
                    </Button>
                  )}
                </div>
              </div>
            </div>
            {user && user?.is_bidder !== 1 && (
              <div className="newColorGrad_bg rounded-3 my-3 px-3 py-4 d-flex justify-content-between align-items-center ">
                <div>
                  <p className="m-0 text-white fs-6">
                    Want to bid on this car?
                  </p>
                  <h6 className="text-white mb-0 fs-4 fw-600">
                    Become a member
                  </h6>
                </div>
                <div>
                  <Link to="/become-a-member">
                    <Button
                      variant="conatined"
                      className="bgSecondary my-2 color-white text-capitalize fw_br"
                    >
                      Become a member
                    </Button>
                  </Link>
                </div>
              </div>
            )}
          </div>
          <div className="col-xl-4 col-lg-5 col-md-12 col-12">
            <div
              style={{ position: "sticky", top: 150, bottom: 0 }}
              className=" boxShadow liveBidsArea  p-3"
            >
              <div className="d-flex justify-content-between align-items-center">
                <h6 className=" color-secondary text-capitalize fs-5 fw-700 pb-2">
                  Top Bidders
                </h6>
                <h6
                  style={{ fontSize: 14 }}
                  className=" color-black text-capitalize fw-500 pb-2"
                >
                  Total Bids: {bidDetails?.length}
                </h6>
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <div
                  style={{ backgroundColor: "firebrick", whiteSpace: "pre" }}
                  className=" mb-3 px-2  py-2  rounded-3 "
                >
                  <p className="m-0 text-white highestBids_text fw-500 ">
                    <span className="fw-700">Highest Bid:</span> PKR{" "}
                    {formatPrice(highest || 0)}
                  </p>
                </div>
                {user && (
                  <div
                    style={{ backgroundColor: "#415dcc", whiteSpace: "pre" }}
                    className=" mb-3 px-2 py-2  rounded-3 "
                  >
                    <p className="m-0 text-white highestBids_text fw-500">
                      <span className="fw-700">My Highest:</span> PKR{" "}
                      {formatPrice(myMaxBid || 0)}
                    </p>
                  </div>
                )}
              </div>
              {/* {highest === myMaxBid && (
                <>
                  <div
                    style={{ backgroundColor: "#21409a" }}
                    className=" px-3 py-1 mb-1 rounded-2"
                  >
                    <h6 style={{ fontSize: 15 }} className=" text-dark m-0  ">
                      <i className="fa-solid fa-arrow-up-long me-2 "></i>{" "}
                      Congratulations! You are the highest bidder
                    </h6>
                  </div>
                </>
              )} */}

              <div></div>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <CircularProgress />
                </div>
              ) : bidDetails?.length ? (
                <>
                  <div className="liveBidderDetail">
                    {bidDetails &&
                      bidDetails?.map((item, index) => (
                        <div
                          className={` ${
                            item?.user_id === user?.id ? "myBid" : "usersBid"
                          } ${
                            item?.user_id === user?.id &&
                            item?.bid_amount === myMaxBid &&
                            "myHighestBid"
                          } ${
                            item?.user_id === user?.id &&
                            index >= 0 &&
                            item?.bid_amount === myMaxBid &&
                            bidDetails?.length > 5
                              ? " bidSticky "
                              : ""
                          } ${
                            item?.bid_id === latestBid &&
                            "animate__bounceInRight animate__animated "
                          }
                          BidsBg   d-flex justify-content-between align-items-center m-2 mb-3`}
                          key={index}
                        >
                          <div>
                            <h6
                              className={`m-0 ${
                                item?.user_id === user?.id &&
                                item?.bid_amount === myMaxBid
                                  ? "color-white"
                                  : "color-black"
                              } fw-700`}
                            >
                              #{index + 1}
                            </h6>
                          </div>
                          <div>
                            <div className="biduserIcon">
                              <p
                                className={`m-0 ${
                                  item?.user_id === user?.id &&
                                  item?.bid_amount === myMaxBid
                                    ? "color-white"
                                    : "color-black"
                                }  `}
                              >
                                {item?.user_id === user?.id
                                  ? item?.name
                                  : "Anonymous"}
                              </p>
                            </div>
                            <div className="bidsFlow w-100    d-flex justify-content-end align-items-center align  rounded ">
                              <div
                                className={` ${
                                  item?.user_id === user?.id &&
                                  item?.bid_amount === myMaxBid
                                    ? "color-white"
                                    : "color-black"
                                }  fw-600 `}
                                style={{ fontSize: 18 }}
                              >
                                {" "}
                                PKR {item?.bid_amount?.toLocaleString()}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </>
              ) : (
                <div className="d-flex justify-content-center align-items-center h-100">
                  <p>No bids available.</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="vehiclePhotos">
          {/* <Carousel interval={null}>
              {vehicleImages &&
                vehicleImages.map((image, index) => (
                  <Carousel.Item
                    key={index}
                    onClick={() => handleImageClick(index)}
                  >
                    <img
                      className="d-block w-100"
                      src={`${imagesPath}/${vehicleDetail?.post_token}/${image?.filename}`}
                      alt={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
                    />
                  </Carousel.Item>
                ))}
            </Carousel> */}

          {/* preview modal */}
          <Modal
            open={previewOpen}
            onClose={handlePreviewClose}
            disableAutoFocus={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="VehiclePhotos_FullPreview VehiclePhotos_PreviewCarousel"
          >
            <Box sx={FullPreview}>
              <button
                className="btn close_primary PreviewModal_CloseBtn"
                onClick={handlePreviewClose}
              >
                <CloseIcon />
              </button>
              <Carousel interval={null}>
                {vehicleImages &&
                  vehicleImages.map((image, index) => (
                    <Carousel.Item
                      key={index}
                      onClick={() => handleImageClick(index)}
                    >
                      <img
                        className="d-block w-100"
                        src={`${imagesPath}/${vehicleDetail?.post_token}/${image?.filename}`}
                        alt={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
                      />
                    </Carousel.Item>
                  ))}
              </Carousel>
            </Box>
          </Modal>
        </div>
        {/* <div className="imgsGallery mt-1">
              {limitedImages &&
                limitedImages.map((image, index) => (
                  <>
                    <div className="imgItem" key={index}>
                      <img
                        src={`${imagesPath}/${vehicleDetail?.post_token}/${image?.filename}`}
                        alt={`${vehicleDetail?.makeName} ${vehicleDetail?.modelName} ${vehicleDetail?.yearName}`}
                        className=" img-fluid"
                      />
                    </div>
                  </>
                ))}
              {limitedImages && limitedImages.length > 6 && (
                <div
                  className="moreImgs"
                  onClick={(index) => handleImageClick(index)}
                >
                  <h6> {vehicleImages && `+${vehicleImages.length - 7}`} </h6>
                </div>
              )}
            </div> */}
        <div className="row flex-column-reverse flex-md-row ">
          <div className="col-lg-8">
            <div className="row card_bg text-capitalize vehicle_key_features p-3 rounded-4 ms-md-0 my-3">
              <h4 className="color-primary mb-3">Details</h4>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Registered In :</strong>
                  {vehicleDetail?.registered_in}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Color :</strong>
                  {vehicleDetail?.vehicle_colour}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Assembly :</strong>
                  Local
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Engine Capacity(cc):</strong>
                  {vehicleDetail?.engine_capacity}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Varient :</strong>
                  {vehicleDetail?.feature_name}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Make</strong>
                  {vehicleDetail?.makeName}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Model</strong>
                  {vehicleDetail?.modelName}
                </div>
              </div>
              <div className="col-lg-6 mb-3">
                <div className="d-flex justify-content-between">
                  <strong>Condition</strong>
                  {vehicleDetail?.vehicle_condition}
                </div>
              </div>
            </div>
            <div className=" ps-0 ps-md-2 vehicle_description mb-3 mt-5">
              <h4 className="color-black mb-3 fs-3 fw-700 ">Description</h4>
              <p>{vehicleDetail?.description}</p>
            </div>
            {vehicleFeatures && (
              <div className="row ps-0 ps-md-2 vehicle_car_features postAdForm postDetailss_info color-black text-capitalize mt-5 ">
                <h4 className="color-black mb-3 fs-3 fw-700">Features</h4>
                <div className="row mx-0">
                  {vehicleFeatures?.abs === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.abs}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        ABS
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.air_bags === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.air_bags}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Air Bags
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.air_conditioning === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.air_conditioning}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        AC
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.alloy_rims === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.alloy_rims}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Alloy Rims
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.am_fm_radio === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.am_fm_radio}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        FM Radio
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.cassette_player === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.cassette_player}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Cassette Player
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.cd_player === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.cd_player}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        CD Player
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.dvd_player === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.dvd_player}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        DVD Player
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.climate_control === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.climate_control}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Climate Control
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.front_camera === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.front_camera}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Front Camera
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.front_speakers === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.front_speakers}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Front Speakers
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.heated_seats === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.heated_seats}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Heated Seats
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.immobilizer_key === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.immobilizer_key}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Immobilizer Key
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.keyless_entry === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.keyless_entry}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Keyless Entry
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.navigation_system === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.navigation_system}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Navigation System
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.power_locks === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.power_locks}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Power Locks
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.power_mirrors === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.power_mirrors}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Power Mirrors
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.power_steering === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.power_steering}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Power Steering
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.power_windows === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.power_windows}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Power Window
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.rear_ac_vents === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.rear_ac_vents}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Rear AC Vents
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.rear_camera === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.rear_camera}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Rear Camera
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.rear_seat_entertainment === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.rear_seat_entertainment}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Rear Seat Entertainment
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.rear_speakers === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.rear_speakers}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Rear Speakers
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.steering_switches === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.steering_switches}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Steering Switches
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.sun_roof === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.sun_roof}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        Sun Roof
                      </label>
                    </div>
                  ) : null}
                  {vehicleFeatures?.usb_and_auxillary_cable === "true" ? (
                    <div className="col-lg-3 col-4 mb-3 form-check md-radioStyle2">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="exampleCheck1"
                        readOnly
                        checked={vehicleFeatures?.usb_and_auxillary_cable}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="exampleCheck1"
                      >
                        USB and Auxillary Cable
                      </label>
                    </div>
                  ) : null}
                </div>
              </div>
            )}
          </div>
          <div className="col-lg-4 pt-3 px-4">
            <h4 className="color-black mb-3 pt-4 fs-3 fw-700 text-center">
              Inspection Report
            </h4>
            <img
              className="img-fluid"
              src={ReportDumy}
              alt="Inspection Report"
              srcSet=""
            />
            {auctionDetail?.iinitial_token !== 0 &&
              auctionDetail?.iinitial_token !== null && (
                <button
                  variant="contained"
                  onClick={handleReport}
                  className="mt-3 bgSecondary rounded-3 fw-600 w-100 color-white py-2 border-0"
                >
                  View Report
                </button>
              )}
          </div>
        </div>

        <div className="col-lg-4">
          {/* <div className="mt-4">
            <h6 className=" color-black fw-700 fs-4 pb-4">Bid Information</h6>
            <div className="d-flex justify-content-between align-items-center bidinfo1">
              <div>
                <h6 className="color-black fw-normal ">Highest Bid</h6>
                <h5 className="fw-700 color-secondary">
                  PKR {formatPrice(highest || 0)}
                </h5>
              </div>
              <div className="" style={{ width: 130 }}>
                <h6 className="color-black fw-normal ">Time Left</h6>
                <h5 className="fw-700 color-secondary">
                  {formatTime(time)}
                  {remainingTime}
                </h5>
                <div>
                  <LinearProgress
                    className="biddingTimerBar"
                    variant="determinate"
                    value={progress}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-4 bidinfo2">
              <div className="bidPriceInc d-flex justify-content-between align-items-center px-2 py-1">
                <button
                  onClick={decreaseValue}
                  disabled={value === startingmount || value <= highest}
                >
                  -
                </button>
                <span>PKR {value}</span>
                <button onClick={increaseValue}>+</button>
              </div>

              <div className="btnBid">
                {user && user ? (
                  <>
                    {userCredit?.activeamount === 0 && isBidFound === false ? (
                      <Button
                        onClick={PurchaseBidOpen}
                        variant="contained"
                        className="py-2 color-white fw-700 bgSecondary rounded-pill w-100 text-capitalize"
                      >
                        Purchase Bid
                      </Button>
                    ) : userCredit?.activeamount !== 0 ? (
                      <form onSubmit={BidSubmit} className="postAdForm">
                        <Button
                          type="submit"
                          variant="contained"
                          className="py-2 color-white fw-700 bgSecondary rounded-pill w-100 text-capitalize"
                        >
                          Bid Now
                        </Button>
                      </form>
                    ) : null}
                  </>
                ) : (
                  <Button
                    onClick={LoginOpen}
                    variant="contained"
                    className="py-2 color-white fw-700 bgSecondary rounded-pill w-100 text-capitalize"
                  >
                    Login to Bid
                  </Button>
                )}
              </div>
            </div>
            <div className="d-flex justify-content-end mt-1">
              <p className="text-center fs-6 fw-600" style={{ color: "grey" }}>
                {msg}
              </p>
            </div>
          </div> */}

          {/* {auctionDetail?.iinitial_token !== 0 &&
            auctionDetail?.iinitial_token !== null && (
              <button
                variant="contained"
                onClick={handleReport}
                className="mt-3 bgSecondary rounded-pill w-100 color-white py-2 border-0"
              >
                View Inspection Report
              </button>
            )} */}

          <div
            className="text-center d-flex align-items-center mt-4 mb-1"
            style={{ flexDirection: "column" }}
          >
            {/* {user && user ? (
                <button
                  className="btn showNumber bgPrimary color-white"
                  style={{ width: "80%" }}
                  // onClick={showNumber}
                >
                  Bid Now
                </button>
              ) : (
                <button
                  className="btn showNumber bgPrimary color-white mb-3"
                  style={{ width: "80%" }}
                  onClick={LoginOpen}
                >
                  Login to Bid
                </button>
              )} */}

            {/* <button
                    className="btn sendMsg bgSecondary color-white"
                    style={{ width: "80%" }}
                  >
                    <MessageIcon sx={{ marginRight: 2 }} />
                    Send Message
                  </button> */}

            {/* bid now modal  */}

            <Modal
              open={bidNowOpen}
              onClose={() => setBidNowOpen(false)}
              disableAutoFocus={true}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="Fw-popups"
            >
              <Box className="md-modal p-3 p-md-4  animate__animated animate__fadeIn animate__faster ">
                <div className="modalBody_area  px-2 ">
                  <div className="">
                    <div>
                      <div className="mb-3 d-flex justify-content-between   ">
                        <div className="bg-dark timeLeft_bgW px-2 px-md-3 py-2  rounded-3 ">
                          <h6 className="text-white mb-0 fw-700">
                            <span className=" text-white  opacity-75 fs-6 fw-500">
                              <i className="fa-regular fa-clock me-2 "></i>Time
                              Left:
                            </span>{" "}
                            {remainingTime}
                          </h6>
                        </div>
                        <div>
                          <h6 className="color-secondary mb-0 fw-600 d-none d-sm-block ">
                            Highest Bid :{" "}
                            <span className="fw-700 fs-5">
                              {formatPrice(highest || 0)}
                            </span>
                          </h6>
                        </div>
                      </div>

                      <div className="d-flex justify-content-between">
                        <div>
                          <h6 className="fw-600 color-secondary fs-5 mb-0">
                            Set Bid Amount
                          </h6>
                          <div className="">
                            <div
                              style={{ whiteSpace: "nowrap" }}
                              className="bidPriceInc border-0 w-100 d-flex justify-content-between align-items-center py-1"
                            >
                              <button
                                onClick={decreaseValue}
                                disabled={
                                  value === startingmount || value <= highest
                                }
                              >
                                -
                              </button>
                              <span className="fs-3 fw-bolder px-3 px-md-4 ">
                                PKR {value?.toLocaleString()}
                              </span>
                              <button onClick={increaseValue}>+</button>
                            </div>
                          </div>
                          <div className=" d-flex column-gap-3 ">
                            <p className="fw-500 color-secondary mb-0">
                              PKR {formatPrice(value)}
                            </p>
                            {value > highest && (
                              <Button
                                sx={{ color: "#20409a" }}
                                className="btn bg-white p-0 fw-600 border-0 shadow-none text-capitalize"
                                onClick={ResetToHighest}
                              >
                                <i className="fa-solid fa-rotate-left me-1"></i>
                                Reset to highest bid
                              </Button>
                            )}
                          </div>
                        </div>
                        {/* <div className="text-end d-none d-sm-block">
                          <h6 className="fw-600 color-secondary fs-5 mb-0 ">
                            Available Bids
                          </h6>
                          <span className="fs-3 fw-bolder ">
                            {availableBids}
                          </span>
                        </div> */}
                      </div>
                      {msg && (
                        <p
                          className="text-start fs-6 fw-500 mb-0 mt-1 "
                          style={{ color: "orange" }}
                        >
                          <i className="fa-solid fa-circle-exclamation me-2"></i>
                          {msg}
                        </p>
                      )}
                    </div>
                    <div className="mt-4">
                      <h6 className="fw-600 fs-5 pb-2">Quick Bids</h6>
                      <div className=" d-flex d-md-block overflow-x-scroll scrollbar_hidden  ">
                        {addAmount?.map((item, index) => (
                          <button
                            key={index}
                            className="btn cursorPointer text-black card_bg rounded-pill px-3 py-1 fs-6 me-2 me-md-3 mb-2"
                            onClick={() => handleAmountPress(item)}
                            style={{ whiteSpace: "nowrap" }}
                          >
                            + {item?.toLocaleString()}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div className="text-center postAdForm  mt-4 d-flex justify-content-center align-items-center column-gap-3 ">
                      {auctionDetail?.iinitial_token !== 0 &&
                        auctionDetail?.iinitial_token !== null && (
                          <Button
                            variant="contained"
                            onClick={handleReport}
                            className=" py-2 px-3 px-md-5 mt-3 rounded-3 fw-600 color-white border-0 text-capitalize"
                            sx={{
                              lineHeight: "unset",
                              whiteSpace: "nowrap",
                              backgroundColor: "#20409a",
                            }}
                          >
                            Inspection Report
                          </Button>
                        )}
                      <form onSubmit={BidSubmit} className="postAdForm ">
                        <Button
                          type="submit"
                          variant="contained"
                          className="py-2 px-3 px-md-5 mt-3 rounded-3 color-white fw-600 bgSecondary rounded-3 text-capitalize"
                          sx={{
                            lineHeight: "unset",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Bid Now
                        </Button>
                      </form>
                    </div>
                  </div>
                </div>
              </Box>
            </Modal>

            <Modal
              open={isOpen}
              onClose={LoginClose}
              disableAutoFocus={true}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              className="Fw-popups"
            >
              <Box className="sm-modal p-3 p-md-4">
                <div className="modalBody_area  px-2 ">
                  <NumberLogin />
                </div>
              </Box>
            </Modal>
            {/* <LoginModal open={isOpen} onClose={LoginClose} /> */}
            <BidRejected
              open={isMemberOpen}
              onClose={MemberBidClose}
              response={errResponse}
            />
            {bidWinner && (
              <WinnerAnounced
                open={winnerOpen}
                onClose={WinnerModalClose}
                Winner={bidWinner}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}
